import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { TableRow } from "../../utils/tables-metadata";
import { CoverageRowData } from "./coverage-rows";
import { BaseTableLayout } from "../../components/base-table-layout";

export type CoverageTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
};

export function CoverageTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Coverage",
}: CoverageTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as CoverageRowData[]}
      columns={[
        { key: "provider", header: "Provider" },
        { key: "policyId", header: "Policy ID" },
        { key: "status", header: "Status" },
      ]}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
    />
  );
}
